import React, { FunctionComponent } from 'react'

export interface Props {
  color: string
  height: string
  width: string
}

export const CancelX: FunctionComponent<Props> = ({
  color = '#001833',
  height = '24px',
  width = '24px',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Icon/Remove</title>
    <desc>Created with Sketch.</desc>
    <defs>
      <polygon
        id="path-x"
        points="16.415 8.414 15 7 11.708 10.293 8.415 7 7 8.414 10.293 11.707 7 15 8.415 16.414 11.708 13.122 15 16.414 16.415 15 13.122 11.707"
      />
    </defs>
    <g
      id="Listing"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Icon/Remove">
        <rect
          id="Rectangle-x"
          fill="#FFFFFF"
          opacity="0"
          x="0"
          y="0"
          width="24"
          height="24"
        />
        <mask id="mask-x" fill="white">
          <use xlinkHref="#path-x" />
        </mask>
        <g id="MaskX" />
        <g id="Mixin/Fill" mask="url(#mask-x)" fill={color}>
          <rect id="Rectangle-x" x="0" y="0" width="24" height="24" />
        </g>
      </g>
    </g>
  </svg>
)
